import { Injectable } from '@angular/core';
import { Store } from '../../core/services/store.service';
import { WarningState } from '../model/warning';

@Injectable({
  providedIn: 'root',
})
export class WarningStoreService extends Store<WarningState> {

  constructor() {
    super(null, 'WarningState');
  }

  clear(){
    this.setState(null);
  }

  public showRedBorder(){
    return this.state && this.state.showRedBorder;
  }
}
